import { render, staticRenderFns } from "./Hotpot.vue?vue&type=template&id=1288eedc&scoped=true&"
import script from "./Hotpot.vue?vue&type=script&lang=js&"
export * from "./Hotpot.vue?vue&type=script&lang=js&"
import style0 from "./Hotpot.vue?vue&type=style&index=0&id=1288eedc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1288eedc",
  null
  
)

export default component.exports